import LogViewerExample from "./Example.BasicLogViewer";

export default [
    {
        code: require("!raw-loader!./Example.BasicLogViewer.tsx"),
        component: LogViewerExample,
        stretchContainer: true,
        title: "Basic Log viewer"
    }
];
